var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListjobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H2.00667",
    stroke: "url(#paint0_linear_1978_9268)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H2.00667",
    stroke: "url(#paint1_linear_1978_9268)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H2.00667",
    stroke: "url(#paint2_linear_1978_9268)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 8H14",
    stroke: "url(#paint3_linear_1978_9268)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 12H14",
    stroke: "url(#paint4_linear_1978_9268)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 4H14",
    stroke: "url(#paint5_linear_1978_9268)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1978_9268",
    x1: 2,
    y1: 8.5,
    x2: 2.00667,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1978_9268",
    x1: 2,
    y1: 12.5,
    x2: 2.00667,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1978_9268",
    x1: 2,
    y1: 4.5,
    x2: 2.00667,
    y2: 4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1978_9268",
    x1: 5.33337,
    y1: 8.5,
    x2: 14,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1978_9268",
    x1: 5.33337,
    y1: 12.5,
    x2: 14,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1978_9268",
    x1: 5.33337,
    y1: 4.5,
    x2: 14,
    y2: 4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListjobs);
export default __webpack_public_path__ + "static/media/list jobs.c8f1002f7d86b2807a1c96f63043adc5.svg";
export { ForwardRef as ReactComponent };